export const PLATFORM = {
    DOUBLECLICK: "doubleclick",
    DOUBLECLICK_SV: "doubleclick_sv",
    FLASHTALKING: "flashtalking",
    FLASHTALKING_EXCEL: "flashtalking_excel",
    FLASHTALKING_ASSETS: "flashtalking_assets",
    TIKTOK: "tiktok",
    FACEBOOK: "facebook",
    OPENDC: "opendc",
    CREATIVEX: "creativex",
    SATALIA: "satalia_preflight",
    GENERIC: "generic",
    GENERIC_LITE: "generic_lite",
} as const;

export const DOWNLOAD_FORMAT = {
    GENERIC: PLATFORM.GENERIC,
    GENERIC_LITE: PLATFORM.GENERIC_LITE,
    DOUBLECLICK: PLATFORM.DOUBLECLICK,
    DOUBLECLICK_SV: PLATFORM.DOUBLECLICK_SV,
    OPENDC: PLATFORM.OPENDC,
    FLASHTALKING: PLATFORM.FLASHTALKING,
    FLASHTALKING_EXCEL: PLATFORM.FLASHTALKING_EXCEL,
    FLASHTALKING_ASSETS: PLATFORM.FLASHTALKING_ASSETS,
    TIKTOK: PLATFORM.TIKTOK,
    FACEBOOK: PLATFORM.FACEBOOK,
    PSD: "psd",
    VIDEO: "video",
    IMAGE: "image",
    IMAGE_JPEG: "image_jpeg",
    IMAGE_NO_SCALE: "image_no_scale",
    IMAGE_JPEG_NO_SCALE: "image_jpeg_no_scale",
} as const;

export type DownloadFormatType = (typeof DOWNLOAD_FORMAT)[keyof typeof DOWNLOAD_FORMAT];

export const ZIP_DOWNLOADS = {
    GENERIC: DOWNLOAD_FORMAT.GENERIC,
    GENERIC_LITE: DOWNLOAD_FORMAT.GENERIC_LITE,
    DOUBLECLICK: DOWNLOAD_FORMAT.DOUBLECLICK,
    DOUBLECLICK_SV: DOWNLOAD_FORMAT.DOUBLECLICK_SV,
    FLASHTALKING: DOWNLOAD_FORMAT.FLASHTALKING,
    OPENDC: DOWNLOAD_FORMAT.OPENDC,
} as const;

export const PSD_DOWNLOAD_FORMATS = {
    IMAGE_NO_SCALE: DOWNLOAD_FORMAT.IMAGE_NO_SCALE,
    IMAGE_JPEG_NO_SCALE: DOWNLOAD_FORMAT.IMAGE_JPEG_NO_SCALE,
    PSD: DOWNLOAD_FORMAT.PSD,
} as const;

export const PUBLISH_PROVIDERS = {
    DOUBLECLICK: PLATFORM.DOUBLECLICK,
    OPENDC: PLATFORM.OPENDC,
    CREATIVEX: PLATFORM.CREATIVEX,
    SATALIA: PLATFORM.SATALIA,
    FACEBOOK: PLATFORM.FACEBOOK,
    ALL: "ALL",
} as const;

export type PublishProvidersType = (typeof PUBLISH_PROVIDERS)[keyof typeof PUBLISH_PROVIDERS];

export const DYCE_PLATFORM = {
    DOUBLECLICK: PLATFORM.DOUBLECLICK,
    DOUBLECLICK_SV: PLATFORM.DOUBLECLICK_SV,
    GENERIC: PLATFORM.GENERIC,
    FLASHTALKING: PLATFORM.FLASHTALKING,
    OPENDC: PLATFORM.OPENDC,
    GENERIC_LITE: PLATFORM.GENERIC_LITE,
    PREVIEW: "preview",
} as const;

export type DycePlatformType = (typeof DYCE_PLATFORM)[keyof typeof DYCE_PLATFORM];
